import {
  ActionNames,
  HostEditActionDefinition,
} from '@wix/editor-platform-host-integration-apis';

import { EditActionsStore } from '../editActionsStore';
import { GroupedNativeActions } from './groupNativeActions';
import { getResolvedEditActions } from './getResolvedEditActions';
import {
  PlatformContext,
  CustomManifestAction,
  EditActionsDictionary,
} from '../types';

export function customizeNativeActions<
  TActions extends GroupedNativeActions['customizedNativeActions'],
  TResult extends
    | HostEditActionDefinition
    | CustomManifestAction = HostEditActionDefinition,
>(
  actions: TActions,
  platformContext: PlatformContext,
): EditActionsDictionary<TResult> {
  const resolvedContributedActions =
    getResolvedEditActions<HostEditActionDefinition>(
      EditActionsStore.getStoreSlice(Object.keys(actions) as ActionNames[]),
      actions,
      platformContext,
    );

  return resolvedContributedActions.reduce<EditActionsDictionary<TResult>>(
    (acc, action) => {
      acc[action.actionName] = {
        ...actions[action.actionName],
        ...action,
      } as TResult;
      return acc;
    },
    {},
  );
}
